// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    InputAdornment,
    Fab,
    OutlinedInput,
    Autocomplete
} from '@mui/material'

import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import React from 'react';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../../components/ToastProvider';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const { showToast, hideToast } = useToast();

    const [searchParams] = useSearchParams();
    const isProduksi = searchParams.get('is_produksi') || '0';

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listModel, setListModel] = useState<any[]>([])

    const [valJenis, setValJenis] = useState<any>(null)
    const [listJenisProduct, setListJenisProduct] = useState<any[]>([])
    const [file, setFile] = useState<any>(null)

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openModelDialog, setOpenModelDialog] = useState<boolean>(false)

    const [txtFile, setTxtFile] = useState<any>(null)

    const [jenisProduct, setJenisProduct] = useState<any>(null)

    useEffect(() => {
        getDoctag()
        getListJenis()
    }, [])


    const handleChangeAutocompleteJenis = (event: SyntheticEvent, newValue: any | null) => {
        setValue('jenis_product', newValue?.nama)
        setValJenis(newValue)

        if (newValue?.nama != null && newValue?.nama != undefined) {
            getModel(newValue?.nama);
        }
    }

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 32
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data;
                    let result = data;

                    if (isProduksi == '0') {
                        result = data.filter(item =>
                            item.nama?.toLowerCase().includes('jasa')
                        );
                        setValue('sysdoctag_id', result.length > 0 ? result[0].id : null);
                        setValDoctag(result.length > 0 ? result[0] : null);
                    } else if (isProduksi == '1') {
                        result = data.filter(item =>
                            !item.nama?.toLowerCase().includes('jasa')
                        );
                        setValue('sysdoctag_id', result.length > 0 ? result[0].id : null);
                        setValDoctag(result.length > 0 ? result[0] : null);
                    }

                    setListDoctag(data);
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const rowClickModel = (e: any) => {
        const data = e.data
        setValue('sdmodel_id', data?.id)
        setValue('model', data?.nama_model)
        setValue('panjang', data.panjang);
        setValue('lebar', data.lebar);
        setValue('tinggi', data.tinggi);
        setValue('nama_product', data.nama_model + '-' + (data.jumlah_product + 1));
        setValue('kode', data.kode + '-' + (data.jumlah_product + 1));
        setValue('keterangan', data.keterangan);
        setOpenModelDialog(false)
    }

    const getListJenis = () => {
        const url = apiUrl.apiUrl + '/sales/model/list-jenis-model'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data;
                    let result = data;

                    if (isProduksi == '0') {
                        result = data.filter(item =>
                            item.nama?.toLowerCase().includes('jasa')
                        );
                        setValue('jenis_product', result.length > 0 ? result[0].nama : null);
                        setValJenis(result.length > 0 ? result[0] : null);
                    }

                    setListJenisProduct(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        sdmodel_id: any,
        model: any,
        syscabang_id: any,
        sysdoctag_id: any,
        sdproduct_id: any,
        mmbarang_id: any,
        kode: any,
        jenis_product: any,
        nama_product: any,
        keterangan: any,
        panjang: any,
        lebar: any,
        tinggi: any,
        image: any,
        is_produksi: any
    }

    const defaultValues = {
        syscabang_id: cabang,
        sdmodel_id: null,
        model: '',
        is_produksi: isProduksi,
        panjang: 0,
        lebar: 0,
        tinggi: 0

    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const customRender = [
        {
            key: "link",
            renderCell: (row: any) =>
                row.data.link != null ? (
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.stopPropagation(); // cegah rowClick
                            setOpenModelDialog(false);
                            Swal.fire({
                                title: 'Preview Gambar',
                                html: `<img src="${row.data.link}" alt="Gambar" style="max-width:100%;max-height:400px;" />`,
                                showCloseButton: true,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                                width: 600,
                            }).then(result => {
                                if (result.isConfirmed) {
                                    setOpenModelDialog(true);
                                }
                            });
                        }}
                    >
                        <Icon icon="mdi:search" fontSize={20} />
                        View Image
                    </Button>
                ) : (
                    <Icon icon="mdi:close-circle-outline" fontSize={24} color="grey" />
                ),
        }
        ,
        {
            key: "id",
            renderCell: (row: any) => (
                <Typography
                    sx={{ fontWeight: 'bold', cursor: 'pointer', color: '#000' }}
                    onClick={e => {
                        e.stopPropagation();
                        window.open(`/sales/model/detail/${row.id}`, '_blank');
                    }}
                >
                    {row.link}
                </Typography>
            ),
        }
    ];

    // UPLOAD ATTACHMENT
    const hiddenFileInput = React.useRef<HTMLInputElement>(null)
    const handleClick = (event: any) => {
        if (hiddenFileInput.current) {
            hiddenFileInput.current.click()
        }
    }

    const handleFile = async (event: any) => {
        const files = event.target.files[0]
        const nameFiles = files.name
        // const image = await resizeFile(files)
        setFile(files)
        setTxtFile(nameFiles)
        setValue('image', files)
    }
    const onSubmit = (data: any) => {
        const url = apiUrl.apiUrl + '/sales/product/add'
        const formData = new FormData();
        formData.append("syscabang_id", data.syscabang_id);
        formData.append("sysdoctag_id", data.sysdoctag_id);
        formData.append("sdmodel_id", data.sdmodel_id);
        formData.append("kode", data.kode);
        formData.append("jenis_product", data.jenis_product);
        formData.append("nama_product", data.nama_product);
        formData.append("keterangan", data.keterangan);
        formData.append("panjang", data.panjang);
        formData.append("lebar", data.lebar);
        formData.append("tinggi", data.tinggi);
        formData.append("is_produksi", data.is_produksi);
        formData.append("image", file);

        axios.post(url, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            }
        }).then(response => {
            if (response.data.success) {
                showToast(response.data.message, 'success');
                const id = response.data.data
                navigate('/sales/product/detail/' + id)
            } else {
                showToast(response.data.message, 'error');
            }
        })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getModel = (jenisModel: any) => {
        const url = apiUrl.apiUrl + '/sales/model/list-combo?mode=full&jenis_model=' + jenisModel
        axios.get(url, {
            params: {},
            headers: { Authorization: `Bearer ${token}` }
        })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListModel(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }
    const addJenisProduct = () => {
        setOpenDialog(false)
        const data = {
            jenis_product: jenisProduct
        }

        const url = apiUrl.apiUrl + '/sales/product/add-jenis-product'
        axios
            .post(url, data, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    const data = response.data.data
                    getListJenis()
                    setValue('jenis_product', data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Product
                    </Typography>
                    <Divider sx={{ m: 0 }} />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={5} md={5}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1, mt: 1 }}>
                                    Jenis Product
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='jenis_product'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valJenis}
                                                options={listJenisProduct}
                                                id='jenis_product'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteJenis}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Jenis Product'
                                                        error={Boolean(errors.jenis_product)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.jenis_product && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    &nbsp;
                                </Typography>
                                <Fab color='primary' size='medium' onClick={() => {
                                    Swal.fire({
                                        title: 'Tambah Jenis Product',
                                        input: 'text',
                                        inputLabel: 'Nama Jenis Product',
                                        inputPlaceholder: 'Masukkan nama jenis Product',
                                        showCancelButton: true,
                                        confirmButtonText: 'Simpan',
                                        cancelButtonText: 'Batal',
                                        inputValidator: (value) => {
                                            if (!value) {
                                                return 'Form ini tidak boleh kosong.'
                                            }
                                        }
                                    }).then(result => {
                                        if (result.isConfirmed && result.value) {
                                            const jenisModel = result.value;
                                            const data = { jenis_model: jenisModel };
                                            const url = apiUrl.apiUrl + '/sales/model/add-jenis-model';
                                            axios
                                                .post(url, data, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                })
                                                .then(response => {
                                                    if (response.data.success) {
                                                        showToast(response.data.message, 'success');
                                                        getListJenis();
                                                    } else {
                                                        showToast(response.data.message, 'error');
                                                    }
                                                })
                                                .catch(error => {
                                                    showToast(error.message, 'error');
                                                });
                                        }
                                    });
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={4} sm={4} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Model
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='model'
                                        control={control}
                                        render={({ field: { value } }) => (
                                            <TextField
                                                label='Model'
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1} hidden={isProduksi == '0' ? true : false}>
                                <Fab color='info' size='medium' onClick={() => {
                                    if (valJenis == null) {
                                        showToast('Silahkan pilih jenis product terlebih dahulu', 'warning');
                                        return;
                                    }
                                    getModel(valJenis ? valJenis.nama : '');
                                    setOpenModelDialog(true);
                                }}
                                    sx={{ display: 'flex', alignItems: 'center', mt: 4 }}
                                >
                                    <Icon icon='mdi:search' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} md={1} sm={1} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    &nbsp;
                                </Typography>
                                <Fab color='primary' size='medium' onClick={() => {
                                    window.open('/sales/model/add', '_blank')
                                }}
                                >
                                    <Icon icon='mdi:plus' fontSize={35} color='white' />
                                </Fab>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Product
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_product'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Product'
                                                error={Boolean(errors.nama_product)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_product && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kode Product
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Kode Product'
                                                error={Boolean(errors.kode)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.kode && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Panjang
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='panjang'
                                        control={control}
                                        rules={{ required: isProduksi == '1' ? true : false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Panjang'
                                                type='number'
                                                error={Boolean(errors.panjang)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.panjang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Lebar
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='lebar'
                                        control={control}
                                        rules={{ required: isProduksi == '1' ? true : false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Lebar'
                                                type='number'
                                                error={Boolean(errors.lebar)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.lebar && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tinggi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tinggi'
                                        control={control}
                                        rules={{ required: isProduksi == '1' ? true : false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tinggi'
                                                type='number'
                                                error={Boolean(errors.tinggi)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tinggi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6} hidden={isProduksi == '0' ? true : false}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Upload Gambar
                                </Typography>
                                <input
                                    type='file'
                                    ref={hiddenFileInput}
                                    onChange={handleFile}
                                    style={{ display: 'none' }}
                                    accept='image/png, image/jpg, image/jpeg'
                                ></input>
                                <FormControl fullWidth>
                                    <Controller
                                        name='image'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <>
                                                <InputLabel htmlFor='input-file'>Gambar</InputLabel>
                                                <OutlinedInput
                                                    label='Foto'
                                                    value={txtFile}
                                                    id='input-file'
                                                    type={'text'}
                                                    error={Boolean(errors.image)}
                                                    startAdornment={
                                                        <Box
                                                            onClick={handleClick}
                                                            onMouseDown={e => e.preventDefault()}
                                                            sx={{ cursor: 'pointer' }}
                                                        >
                                                            <InputAdornment position='start'>
                                                                Pilih Gambar &nbsp;
                                                                <IconButton edge='start' aria-label='paperclip'>
                                                                    <Icon fontSize={20} icon={'mdi:paperclip'} />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </Box>
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                    {errors.image && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Keterangan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Jenis Product
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1, color: '#212121' }}>
                                Jenis Product
                            </Typography>
                            <FormControl fullWidth>
                                <TextField
                                    label='Jenis Product'
                                    onChange={(e) => setJenisProduct(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} sx={{ textAlign: 'center', my: 2 }}>
                            <Button variant='contained' onClick={() => addJenisProduct()} disabled={jenisProduct == null || jenisProduct == '' ? true : false}>
                                SIMPAN
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openModelDialog}
                onClose={() => setOpenModelDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        List Model {valJenis ? valJenis.nama : ''}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 4 }}>
                    <Grid container spacing={4}>
                        <MsiDatagrid array={listModel} rowClick={rowClickModel} customRender={customRender} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenModelDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
